const STORAGE_KEY = 'lewouhmart_referral_device_id';

/** Stable per-browser id sent at registration to tie referral signups to a device bucket (server-side fraud checks). */
export function getOrCreateReferralDeviceId(): string {
  try {
    const existing = window.localStorage.getItem(STORAGE_KEY);
    if (existing && existing.length >= 8) return existing;
    const id =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `zm_${Date.now()}_${Math.random().toString(36).slice(2, 14)}`;
    window.localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    return `zm_fallback_${Date.now()}`;
  }
}
